import {ChangeDetectorRef, Component, ElementRef, Input, OnInit, ViewChild} from '@angular/core';
import {FormBuilder, FormGroup} from '@angular/forms';
import {ActionSheetController, AlertController, IonTextarea, LoadingController, ModalController, Platform} from '@ionic/angular';
import {TranslateService} from '@ngx-translate/core';
import {DataService} from 'src/app/services/data.service';
import {DisclaimersService} from 'src/app/services/disclaimers.service';
import {ErrorHandlerService} from 'src/app/services/error-handler.service';
import {LanguageService} from 'src/app/services/language.service';
import {LoaderService} from 'src/app/services/loader.service';
import {ToastService} from 'src/app/services/toast.service';
import {FileOpener} from "@ionic-native/file-opener/ngx";
import {PlatformService} from "../../platform.service";
import {HttpClient} from "@angular/common/http";
import {Camera, CameraResultType, CameraSource, Photo} from "@capacitor/camera";
import {Directory, DownloadFileOptions, Filesystem} from "@capacitor/filesystem";
import {Browser} from "@capacitor/browser";
import {map} from "rxjs/operators";

const IMAGE_DIR = 'stored-images';

@Component({
    selector: 'app-request-appeal',
    templateUrl: './request-appeal.page.html',
    styleUrls: ['./request-appeal.page.scss'],
})
export class RequestAppealPage {
    @ViewChild('reason') AppealReason: IonTextarea;

    @Input() violation: any;
    appeal: FormGroup = new FormGroup({})
    errors = {};

    files: any[] = [];
    loaded = false;
    uploads = {};
    image;
    @ViewChild('filepicker', {static: false}) picker: ElementRef;

    constructor(
        private toastSrv: ToastService,
        private errorHandlerSRV: ErrorHandlerService,
        public disclaimerSRV: DisclaimersService,
        private fb: FormBuilder,
        private loaderSRV: LoaderService,
        public modalController: ModalController,
        public dataService: DataService,
        public translateService: TranslateService,
        private loadingCtrl: LoadingController,
        public changeDetectorRef: ChangeDetectorRef,
        private toasterSRV: ToastService,
        private actionSheetCtrl: ActionSheetController,
        private plt: Platform,
        private alertController: AlertController,
        private fileOpener: FileOpener,
        private platformSRV: PlatformService,
        private http: HttpClient,
        public platform: Platform,
    ) {
        this.appeal = this.fb.group({
            "reason": "",
            "file": ""

        })
    }

    ionViewDidEnter() {
        var disclaimer;
        disclaimer = this.disclaimerSRV.disclaimers.find(disclaimer => disclaimer['data_trigger'] == 'appeals-page-loaded' && disclaimer['locale'] == this.dataService.selected && disclaimer['content'] != null)

        if (disclaimer && disclaimer['active']) {

            this.dataService.createAndOpenModal(disclaimer).then(data => {
                if (data) {
                    this.AppealReason.setFocus()
                } else {
                    this.onCancelModal()
                }
            })
        }
    }

    ngAfterViewInit() {

    }

    onCancelModal() {
        this.modalController.dismiss();
    }
    
    async onSubmitAppeal() {
        this.loaderSRV.showLoader(this.translateService.instant('keys.data.common.loading') || 'Loading...')
        const url = `violations/appeals/${this.violation.ViolationID}`;

        var loading

        if (this.files.length == 1) {
            loading = await this.loadingCtrl.create({
                message: 'Uploading image...',

            });
            await loading.present();
        } else if (this.files.length > 1) {
            loading = await this.loadingCtrl.create({
                message: 'Uploading images...',

            });
            await loading.present();
        }


        var documents = []
        this.files.forEach(element => {
            documents.push(element.data)
        });

        this.http
            .post(
                `${this.dataService.apiUrl}/` + url,
                {documents, "_token": this.dataService.csrfToken, reason: this.appeal.value['reason']}
            )
            .subscribe({
                next: response => {
                    this.loaderSRV.dismissLoader()

                    if (response['status'] == "success") {
                        this.files = []
                        this.loaderSRV.dismissLoader()
                        this.toasterSRV.presentToast(response['message'])

                        this.modalController.dismiss({
                            reload: true,
                        });

                    } else {
                        this.loaderSRV.dismissLoader()
                        this.errorHandlerSRV.displayErrorMessage(response, true)
                    }

                    this.changeDetectorRef.detectChanges()
                },

                error: err => {
                    this.loaderSRV.dismissLoader()
                    this.errorHandlerSRV.displayErrorMessage(err, true)
                    this.changeDetectorRef.detectChanges()
                }
            });

        if (loading) {
            await loading.dismiss();
        }
    }

    async removeFile(fileIndex) {
        const alert = await this.alertController.create({
            header: this.translateService.instant('keys.data.common.remove_file') || 'Remove File?',
            buttons: [
                {
                    text: this.translateService.instant('keys.data.common.cancel') || 'Cancel',
                    role: 'cancel',
                    handler: () => {

                    },
                },
                {
                    text: this.translateService.instant('keys.data.common.confirm') || 'Confirm',
                    role: 'confirm',
                    handler: () => {
                        this.files.splice(fileIndex, 1)
                    },
                },
            ],
        });

        await alert.present();
    }

    getFileReader(): FileReader {
        const fileReader = new FileReader();
        const zoneOriginalInstance = (fileReader as any)["__zone_symbol__originalInstance"];
        return zoneOriginalInstance || fileReader;
    }

    async fileSelected(event) {
        var type = event.target.files[0].name.substring(event.target.files[0].name.lastIndexOf("."))

        if (this.platformSRV.isNative.value) {
            var fileReader = this.getFileReader()
            fileReader.onload = (imgsrc) => {
                this.saveFileFromDevice((imgsrc.target as FileReader).result, type)

            }
            fileReader.onloadend = () => {
                this.picker.nativeElement.value = "";
                setTimeout(() => {
                    this.changeDetectorRef.detectChanges();
                }, 250);

            }

            fileReader.readAsDataURL(event.target.files[0])


        } else {
            var fileReader = new FileReader();
            fileReader.readAsDataURL(event.target.files[0])
            fileReader.onload = () => {


                this.saveFileFromDevice(fileReader.result, type)


            }
            fileReader.onloadend = () => {
                this.picker.nativeElement.value = "";
                setTimeout(() => {
                    this.changeDetectorRef.detectChanges();
                }, 250);

            }

        }

    }

    async selectFileOnAdroid() {
        const actionSheet = await this.actionSheetCtrl.create({
            header: this.translateService.instant('keys.data.profile.select_files_to_upload') || 'Select Files to Upload',
            mode: "ios",
            buttons: [
                {
                    text: this.translateService.instant('keys.data.profile.from_device') || 'From Device',
                    icon: "folder",
                    handler: (async () => {
                        this.picker.nativeElement.click()

                    })
                    ,

                },
                {
                    text: this.translateService.instant('keys.data.profile.from_camera') || 'From Camera',
                    icon: "camera",
                    handler: (async () => {
                        const image = await Camera.getPhoto({
                            quality: 90,
                            allowEditing: false,
                            resultType: CameraResultType.Uri,
                            source: CameraSource.Camera
                        })
                        if (image) {
                            this.saveImageFromCamera(image)
                        }

                    })
                    ,

                },
                {
                    text: this.translateService.instant('keys.data.common.cancel') || 'Cancel',
                    role: 'cancel',
                    data: {
                        action: 'cancel',
                    },
                }
            ]
        })
        actionSheet.present()
    }

    async selectFileOnIOS() {
        this.picker.nativeElement.click()
    }

    async selectFile() {
        if (this.platform.is('ios')) {
            this.selectFileOnIOS()
        } else {
            this.selectFileOnAdroid()
        }
    }

    async saveFileFromDevice(base64, type) {


        const fileName = new Date().getTime() + type;
        const savedFile = await Filesystem.writeFile({
            path: `${IMAGE_DIR}/${fileName}`,
            data: base64,
            directory: Directory.Data,
            recursive: true
        });

        this.files.push({
            name: fileName,
            path: `${IMAGE_DIR}/${fileName}`,
            data: base64,
            type: type
        });

    }

    async saveImageFromCamera(file) {

        if (this.platformSRV.isNative.value) {
            const base64Data = await this.readAsBase64(file);
            const fileName = new Date().getTime() + '.' + file.format;
            const savedFile = await Filesystem.writeFile({
                path: `${IMAGE_DIR}/${fileName}`,
                data: base64Data,
                directory: Directory.Data,
                recursive: true
            });

            this.files.push({
                name: fileName,
                path: `${IMAGE_DIR}/${fileName}`,
                data: 'data:image/jpeg;base64,' + base64Data,
            });
        } else {
            const base64Data = await this.readAsBase64(file);
            const fileName = new Date().getTime() + '.' + file.format;
            const savedFile = await Filesystem.writeFile({
                path: `${IMAGE_DIR}/${fileName}`,
                data: base64Data,
                directory: Directory.Data,
                recursive: true
            });

            this.files.push({
                name: fileName,
                path: `${IMAGE_DIR}/${fileName}`,
                data: base64Data,
            });
        }


    }

    private async readAsBase64(photo: Photo) {
        if (this.plt.is('hybrid')) {
            const file = await Filesystem.readFile({
                path: photo.path
            });

            return file.data;
        } else {
            // Fetch the photo, read as a blob, then convert to base64 format
            const response = await fetch(photo.webPath);
            const blob = await response.blob();

            return await this.convertBlobToBase64(blob) as string;
        }
    }

// Helper function
    convertBlobToBase64 = (blob: Blob) => new Promise((resolve, reject) => {
        const reader = new FileReader;
        reader.onerror = reject;
        reader.onload = () => {
            resolve(reader.result);
        };
        reader.readAsDataURL(blob);
    });

    async downloadFile(link, name) {
        const alert = await this.alertController.create({
            header: this.translateService.instant('keys.data.common.download') || 'Download',
            buttons: [
                {
                    text: this.translateService.instant('keys.data.common.cancel') || 'Cancel',
                    role: 'cancel',
                    handler: () => {

                    },
                },
                {
                    text: this.translateService.instant('keys.data.common.confirm') || 'Confirm',
                    role: 'confirm',
                    handler: async () => {
                        await alert.dismiss()
                        if (this.platformSRV.isNative.value) {
                            this.loaderSRV.showLoader(this.translateService.instant('keys.data.common.downloading') || 'downloading...')
                            const options: DownloadFileOptions = {
                                url: link,
                                path: name,
                                directory: Directory.Data,
                                method: 'GET',

                            };
                            try {
                                const response = await Filesystem.downloadFile(options);
                                if (response.path) {


                                    var fileOpenerType

                                    const read = await Filesystem.readFile({
                                        path: name,
                                        directory: Directory.Data,
                                    });


                                    const imagePath = await Filesystem.writeFile({
                                        path: name,
                                        data: read.data,
                                        directory: Directory.External,

                                    })


                                    this.fileOpener.showOpenWithDialog(imagePath.uri, fileOpenerType).then(() => {
                                        this.loaderSRV.dismissLoader()
                                    }).catch(err => {
                                        this.errorHandlerSRV.displayErrorMessage(err, true)
                                    })
                                }
                            } catch (err) {
                                this.loaderSRV.dismissLoader()
                                this.errorHandlerSRV.displayErrorMessage(err, true)
                            }

                        } else {
                            await Browser.open({url: link});
                        }
                    },
                },
            ],
        });

        await alert.present();


    }


}
